<div class="card" [ngClass]="{'selected': isSelected}" (click)="onCardClick()">
    <!-- Card Image -->
    <div class="card-img-container">
      <img [src]="node.img" class="card-img-top">
    </div>

    <div class="card-body">
      <h5 class="card-text" *ngIf="node.description">{{ node.description }}</h5>
      <p class="card-title">{{ node.name }}</p>

      <!-- Node with children -->
      <div *ngIf="node.nodes && node.nodes.length > 0" class="node-content" (click)="onCardClick()">
        <div class="children-count">
          <i class="bi bi-folder"></i>
          {{ node.nodes.length }} Types
        </div>
        <button class="btn btn-outline rounded-circle border-0 ms-2">
          <i class="bi bi-arrow-right"></i>
        </button>
      </div>

      <!-- Node with models -->
      <div *ngIf="node.models && node.models.length > 0" class="model-content">
        <button
          class="btn btn-outline-primary btn-sm ms-2"
          [disabled]="isSelected"
          (click)="openModelSelection()">
          {{ node.models.length }} options to select
        </button>
      </div>
    </div>
  </div>
